import { FunctionComponent } from 'react';

import useCreditSearchTable from './useCreditSearchTable';

import { Header, Rows, Visibility } from '../components';

const CreditSearchTable: FunctionComponent = function () {
  const { showTable, table, rows, onClick } = useCreditSearchTable();
  return (
    <div className="w-full max-w-full flex flex-col flex-1 overflow-x-scroll">
      {showTable ? (
        <>
          <Visibility
            table={table}
            columns={[
              { id: 'id', label: 'Toggle Credit ID column visibility' },
            ]}
          />
          <table className="mx-auto">
            <Header table={table} />
            <Rows rowModel={rows} onClick={onClick} />
          </table>
        </>
      ) : (
        <p className="m-auto text-16-20-em">No results</p>
      )}
    </div>
  );
};

export default CreditSearchTable;
